import React from "react";
import { PenTool, Zap, ShieldCheck, ArrowUpRight } from "lucide-react";

const CELLS = [
  {
    k: "01",
    title: "Designed, not templated.",
    desc: "Every pixel is considered. No drag-and-drop, no cookie-cutter kits.",
    Icon: PenTool,
    testid: "what-we-do-cell-01",
  },
  {
    k: "02",
    title: "Fast to ship.",
    desc: "We ship in days, not months. Simple on purpose, fast by design.",
    Icon: Zap,
    testid: "what-we-do-cell-02",
  },
  {
    k: "03",
    title: "Built to last.",
    desc: "Clean code, easy to maintain, easy to grow with you later.",
    Icon: ShieldCheck,
    testid: "what-we-do-cell-03",
  },
];

export default function WhatWeDo() {
  return (
    <section
      id="what"
      data-testid="what-we-do-section"
      className="relative py-16 sm:py-24 lg:py-32 border-t border-[rgba(10,10,10,0.08)]"
    >
      <div className="section-container">
        <div className="mx-auto max-w-[900px]">
          <div
            className="reveal tick-label"
            data-testid="what-we-do-eyebrow"
          >
            What we do
          </div>
          <h2
            className="reveal font-sans-display mt-4 sm:mt-5 text-[30px] sm:text-[44px] lg:text-[56px] font-bold leading-[1.08] sm:leading-[1.05] tracking-[-0.03em] text-[#0a0a0a]"
            data-testid="what-we-do-heading"
          >
            One thing, done{" "}
            <span className="font-display italic font-normal">really</span>{" "}
            well.
          </h2>
          <p
            className="reveal reveal-delay-1 mt-4 sm:mt-5 text-[15.5px] sm:text-[18px] leading-[1.6] text-[#0a0a0a]/70 max-w-[620px]"
            data-testid="what-we-do-paragraph"
          >
            We build websites. That's it. No packages, no funnels, no
            complicated options. You tell us about your business, we design and
            ship a site that feels like yours — modern, fast, and made to last.
          </p>

          <div
            className="reveal reveal-delay-2 mt-10 sm:mt-12 grid grid-cols-1 sm:grid-cols-3 gap-px bg-[rgba(10,10,10,0.08)] rounded-2xl overflow-hidden border border-[rgba(10,10,10,0.1)] shadow-[0_20px_50px_-30px_rgba(10,10,10,0.2)]"
          >
            {CELLS.map((c) => (
              <Cell key={c.k} {...c} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function Cell({ k, title, desc, Icon, testid }) {
  return (
    <div
      className="group relative bg-[hsl(var(--background))] p-6 sm:p-7 card-lift"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[#0a0a0a] text-[#fbf9f4] shadow-[2px_2px_0_0_rgba(10,10,10,0.15)]">
          <Icon className="size-4" strokeWidth={2} />
        </span>
        <span className="font-mono-mark text-[11.5px] text-[#0a0a0a]/40">
          {k} / 03
        </span>
      </div>
      <div className="mt-5 text-[16.5px] font-semibold tracking-tight text-[#0a0a0a]">
        {title}
      </div>
      <div className="mt-1.5 text-[14px] leading-[1.55] text-[#0a0a0a]/65">
        {desc}
      </div>
      <ArrowUpRight
        className="absolute top-6 right-6 size-4 text-[#0a0a0a]/0 group-hover:text-[#0a0a0a]/50 transition-colors duration-200 btn-arrow"
        strokeWidth={2}
      />
    </div>
  );
}
